import React from "react";
import LibraryContent from "../FunctionComponents/LibraryFolder/LibraryContent";

function Library() {
  return (
    <>
      <LibraryContent />
    </>
  );
}

export default Library;
